import React from 'react'
import Cards from '../components/Cards'

const Home = () => {
    return (
        <Cards />
    )
}

export default Home
